import { camelizeKeys } from 'humps'

const configJson = document.documentElement.dataset.config

const Configuration = camelizeKeys(JSON.parse(configJson))

export default Configuration
